$(document).ready(function () {
    'use strict';

    $('.itemBackButton').on('click', function (e) {
        e.preventDefault();
        window.history.back();
    });
});